import { OnDemandVolumeEstimate } from 'src/types/graphql'

/**
 * Shared form shape for the on-demand wizard. All enum-typed fields are
 * stored as plain `string` so RHF's `setValue` typing doesn't collapse to
 * `never` when multiple enum-union fields share the same form. Coerced
 * back to their enum types at submit time in `OnDemandWizard/index.tsx`.
 *
 * `volumeEstimate` is the one exception — kept as the enum because its
 * default value (`Unsure`) is already a valid member, and the live price
 * reveal in step 2 reads it as the enum directly.
 */
export type IWizardForm = {
  name: string
  phone: string
  /** Optional — enables the post-submit confirmation email + a sales
   *  fallback channel + retargeting Custom Audience matches. Empty string
   *  when the user skips. Validation is shape-only and non-blocking. */
  email: string
  pickupCity: string
  /** Zone within the pickup city (e.g. San Pedro, Apodaca). Sourced from
   *  `OnDemandCityConfig.coverageZones`. Optional — empty string when the
   *  user skips. Replaces the legacy free-text `pickupAddress` field at
   *  step 1; the address is still in the form shape for backward compat
   *  but is no longer rendered. */
  pickupZone: string
  pickupAddress: string
  personaType: string
  pickupTiming: string
  storageDuration: string
  pickupLogistics: string
  volumeEstimate: OnDemandVolumeEstimate
  notes: string
  /** Hidden anti-spam honeypot. Real users will leave this blank. */
  company_url: string
}

export type WizardStep = 1 | 2 | 3 | 4
export const TOTAL_STEPS = 4 as const
